/*
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-11-04 15:23:08
 * @LastEditors: Liu ShuaiBo
 * @LastEditTime: 2021-11-04 15:24:16
 */
import request from '@/utils/request'
import { AjaxMethod } from '@/utils/dataMap'
// 推广记录公开分享
export const promotionList = (params) => {
    return request({
        url: '/api/promotion/list',
        data: params,
        method: AjaxMethod.post
    })
}

// 推广记录指定分享
export const promotionPublicList = (params) => {
    return request({
        url: '/api/promotion/list-public',
        data: params,
        method: AjaxMethod.post
    })
}

// 推广记录商品列表
export const promotionShopList = (params) => {
    return request({
        url: '/api/promotion/product-list',
        data: params,
        method: AjaxMethod.post
    })
}

// 达人联系人列表
export const contactList = (params) => {
    return request({
        url: '/api/talent/contact-select-list',
        data: params,
        method: AjaxMethod.post
    })
}

// 达人列表
export const talentList = (params) => {
    return request({
        url: '/api/talent/select-list',
        data: params,
        method: AjaxMethod.post
    })
}

// 团队达人列表
export const teamTalentList = (params) => {
  return request({
      url: '/api/talent/team-anchor-select-list',
      data: params,
      method: AjaxMethod.post
  })
}

// 分享
export const shareProduct = (params) => {
    return request({
        url: '/api/product-group/share-product',
        data: params,
        method: AjaxMethod.post
    })
}

// 推广记录查看列表
export const shareviewList = (params) => {
    return request({
        url: '/api/promotion/share-view-list',
        data: params,
        method: AjaxMethod.post
    })
}

// 推广列表
export const productList = (params) => {
    return request({
        url: '/api/promotion/product-lib-list',
        data: params,
        method: AjaxMethod.post
    })
}

// 达人商务查看详情
export const productDetail = (params) => {
    return request({
        url: '/api/promotion/product-lib-detail',
        data: params,
        method: AjaxMethod.post
    })
}
